export default () => {
    return useFetchWithTanstackQuery({
        queryKey: ['messages'],
        queryFn: () => $fetch('/api/translations/messages'),
        storageType: 'sessionStorage',
    })
}
